/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-restricted-globals */

import { Modal } from '@material-ui/core';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { isMacOs } from 'react-device-detect';
import CalendarIcon from "../../public/icons/blank-calendar-black.svg";
import CrossIcon from "../../public/icons/cross-icon.svg";
import ConversationsService from '../../services/conversations/conversations.service';
import DateTimePickerComponent from '../datetime-picker/datetime-picker.component';
import FileUploader from './fileUpload';
import styles from './recording-upload.module.css';

interface RecordingUploadModalProps {
  showRecordingUploadModal: boolean;
  handleClose: () => void;
  customerId: number;
  userEmail: string;
  handleShowUploadSuccessModal:()=>void;
}

interface Part {
  ETag: string;
  PartNumber: number;
}


const RecordingUploadModal: React.FC<RecordingUploadModalProps> = props => {
  const {
    showRecordingUploadModal,
    handleClose,
    customerId,
    userEmail,
    handleShowUploadSuccessModal,
  } = props;

  const [isDateModalOpen, setIsDateModalOpen] = useState<boolean>(false);
  const [conversationDate, setConversationDate] = useState();

  const [recordingFile, setRecordingFile] = useState<string>("");
  const [uploadedFile, setUploadedFile] = useState<File>(null);

  const [recordingUrl, setRecordingUrl] = useState<string>('');
  const [recordingUrlError, setRecordingUrlError] = useState<string>('');
  const [loading, setLoading]=useState<boolean>(false)
  const [uploadStatus, setUploadStatus]=useState<string>("")
  const [focusDate ,setFocusDate]=useState<boolean>(false)

  const handleNextMeetingChange = date => {
    setConversationDate(date);
  };

  const handleRecordingFile = file => {
    setRecordingFile(file);
  };

  const handleUploadedFile = file => {
    setUploadedFile(file)
  }

  async function isAudioUrlValid(url) {
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      return response?.status === 200;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  useEffect(()=>{
    if(conversationDate){
        setFocusDate(false)
    }
  }, [conversationDate])

  return (
    <Modal className={styles['modal']} open={showRecordingUploadModal}>
      <div className={styles['inner-container']}>
        <div className={styles['dialog-content']}>
          <div
            className="w-4 h-4 absolute right-3 "
            role="button"
            tabIndex={0}
            onClick={handleClose}
            aria-hidden
          >
            <CrossIcon />
          </div>
          <div className={styles['content-header']}>
            Upload Conversation Recording
          </div>
          <div className="mt-6">
            <div className="font-semibold text-xs lg:text-base">
              Conversation Date & Time
            </div>
            <div className={`border rounded-lg w-max ${focusDate? "border-red-600" : "border-audio-timeline"}`}>
              <button
                type="button"
                className="w-max px-3 py-3 rounded-lg text-primary-grey text-sm lg:text-base cursor flex"
                onClick={() => {
                  setIsDateModalOpen(true);
                }}
              >
                <span className="">
                  {conversationDate
                    ? format(conversationDate, 'dd/MM/yyyy')
                    : 'dd/mm/yy'}
                </span>
                <span className="px-2">|</span>
                <span>
                  {conversationDate
                    ? format(conversationDate, 'HH:mm a')
                    : 'hh:mm'}
                </span>
                <span className='ml-3 flex justify-center items-end m-auto'>
                <CalendarIcon className="" />
                </span>
              </button>
              {isDateModalOpen && (
                <DateTimePickerComponent
                  open={isDateModalOpen}
                  date={new Date()}
                  handleClose={setIsDateModalOpen}
                  handleDateChange={newDate => handleNextMeetingChange(newDate)}
                  allowPastDate
                />
              )}
            </div>
          </div>
          <div className="mt-4">
            <div className="font-semibold text-xs lg:text-base">
              Upload file
            </div>
            <div className="mt-1.5">
              <FileUploader
                accept={['.mp3', '.wav', '.aac', '.mp4']}
                chunkSize={200 * (isMacOs ? (1000 * 1000) : (1024 * 1024))} // equates to 200MB
                maxSize={200 * (isMacOs ? (1000 * 1000) : (1024 * 1024))}
                canCancelUpload
                onFileUpload={() => {}}
                handleRecordingFile={handleRecordingFile}
                handleUploadedFile={handleUploadedFile}
              />
            </div>
          </div>
          <div className="text-center py-3 text-primary-grey text-xs lg:text-base">
            OR
          </div>
          <div>
            <div className="text-primary-dark font-semibold text-xs lg:text-base">
              Add URL/Link of the file
            </div>
            <div className="text-primary-grey text-xxs lg:text-sm mt-1 mb-2">
              The URL or link needs to be publicly accessible
            </div>
            <div className={styles['name-input-elem']}>
              <input
                type="text"
                className="w-full rounded-md border-0 text-xs lg:text-sm h-8 lg:h-10"
                value={recordingUrl}
                name="recordingUrl"
                onChange={event => {
                  setRecordingUrlError('');
                  setRecordingUrl(event.target.value);
                }}
              />
            </div>
            {recordingUrlError.length > 0 && (
              <div className="text-xs text-red-700">{recordingUrlError}</div>
            )}
          </div>
          <div className="w-full mt-6">
            <button
              disabled={
                loading ||
                (!recordingUrl.length && !recordingFile?.length) ||
                recordingUrlError?.length > 1
              }
              type="button"
              className={`flex mx-auto text-sm font-semibold bg-secondary rounded-lg text-white w-52 h-11 text-center items-center
                justify-center my-auto ${
                  (loading ||
                    (!recordingUrl.length && !recordingFile?.length) ||
                    recordingUrlError?.length > 1) &&
                  'opacity-80'
                }`}
              onClick={async () => {
                if ((recordingUrl?.length && recordingFile?.length) || !conversationDate){
                    setFocusDate(true)
                    return
                }
                if (recordingUrl?.length > 0) {
                  if (
                    !recordingUrl?.endsWith('.mp3') &&
                    !recordingUrl?.endsWith('.wav') &&
                    !recordingUrl?.endsWith('.aac') &&
                    !recordingUrl?.endsWith('.mp4')
                  ) {
                    setRecordingUrlError(
                      'The above link is not valid audio url, check and try again.',
                    );
                    return;
                  }
                  const response = await isAudioUrlValid(recordingUrl);
                  if (response) {
                    setRecordingUrlError('');
                  } else {
                    setRecordingUrlError(
                      'The above link is not publicly accessible, check and try again.',
                    );
                    return;
                  }
                }

                if (recordingUrlError?.length < 1) {
                  try {
                    setLoading(true);
                    let uploadResponse = null;
                    // Handle the uploaded file scenario
                    if (recordingUrl?.length === 0) {
                      const fileExtn = uploadedFile.name.split('.')?.[1]
                      const initiatedUploadObj = await ConversationsService.initiateMultipartUpload({
                        userEmail,
                        scheduledAt: conversationDate,
                        customerId,
                        fileExtn
                      });

                      const partSize = 5 * 1024 * 1024; // 5MB chunk size
                      const parts: Part[] = [];

                      for (let i = 0; i < uploadedFile.size; i += partSize) {
                        const partNumber = Math.floor(i / partSize) + 1;
                        const part = uploadedFile.slice(i, i + partSize);

                        const uploadUrl = await ConversationsService.getPresignedUrl({
                          uploadId: initiatedUploadObj?.data?.data?.uploadId,
                          uploadKey: initiatedUploadObj?.data?.data?.uploadKey,
                          partNumber
                        });

                        const etag = await ConversationsService.uploadPart(
                          uploadUrl?.data?.data?.presignedUrl, 
                          part, 
                          fileExtn === 'mp4' ? 'video/mp4' : 'audio/mpeg'
                        );
                        parts.push({ ETag: etag, PartNumber: partNumber });
                      }

                      const multipartUploadResponse = await ConversationsService.completeMultipartUpload({
                        uploadId: initiatedUploadObj?.data?.data?.uploadId,
                        uploadKey: initiatedUploadObj?.data?.data?.uploadKey,
                        uploadedParts: parts
                      });

                      uploadResponse = multipartUploadResponse?.data?.data;
                      setUploadStatus(uploadResponse);
                    }
                    else {
                      // Handle an uploaded link
                      const response =
                        await ConversationsService.recordingUploadSync({
                          recording_url: recordingUrl,
                          recording_type: 'recording_url',
                          email: userEmail,
                          scheduled_at: conversationDate,
                          customer_id: customerId
                        });
                      uploadResponse = response?.data?.data;
                      setUploadStatus(uploadResponse);
                    }

                    setLoading(false);
                    if (uploadResponse === 'success') {
                      handleShowUploadSuccessModal();
                    }
                  } catch (error) {
                    setLoading(false);
                    console.log(error);
                  }
                }
              }}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
          {uploadStatus === 'failed' && (
            <div className="text-xs text-red-600 mt-2 text-center">
              Could not upload the given file, please check and try again.
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RecordingUploadModal;
